<template lang="pug">

div.tabs-container(v-if="$route.params.protein" id="tabs_container")
    span.tabs().protein_name {{ $route.params.protein }}
    router-link.tabs(:to="{ name: 'summary', params: { protein: $route.params.protein }}")  Protein overview
    //router-link.tabs(:to="{ name: 'modifications', params: { protein: $route.params.protein }}") Modifications
    router-link.tabs(:to="{ name: 'peptides', params: { protein: $route.params.protein }}") Peptides
    router-link.tabs(:to="{ name: 'projects', params: { protein: $route.params.protein }}") Projects
    router-link.tabs(:to="{ name: 'structures', params: { protein: $route.params.protein }}") Structures
    router-link.tabs(:to="{ name: 'mutations', params: { protein: $route.params.protein }}") Mutations
    router-link.tabs(:to="{ name: 'dynamic', params: { protein: $route.params.protein }}") Dynamic properties
</template>

<script>
export default {
    name: 'Tabs',
    data: function() {
        return {}
    },
    created: function() {
        window.addEventListener('scroll', ()=> {
            if(window.scrollY > 50) {
                document.getElementById('tabs_container').classList.add('fixed-top')
                const navbar_height = document.querySelector('.tabs-container').offsetHeight
                document.body.style.paddingTop = navbar_height + 'px'
            } else {
                document.getElementById('tabs_container').classList.remove('fixed-top')
                document.body.style.paddingTop = 0
            }
        })
    },
    methods: {}
}
</script>

<style lang="scss">
@import '../assets/scss/variables';
.tabs-container{
    height: 50px;
    line-height: 50px;
    background-color: white;
    border-bottom: 1px solid $secondary;
    margin-bottom: 25px;
    padding-left: 1rem;
    span.protein_name {
        padding-right: 100px;
    }
    a {
        color: $primary_dark;
        padding: 16px 10px;
        font-weight: 600;
    }
    .router-link-active {
        // text-decoration: underline;
        color: $secondary;
        background-color: white;
        border-top: 2px solid $secondary;
        border-top: 1px solid $secondary;
        padding-top: 14px;
        padding-bottom: 13px;
    }
}


</style>
